var $6ccd80391c1df6b7$exports = {};
const $6ccd80391c1df6b7$var$DEFAULT_CONFIG = {
    schedule: {},
    foreground_color: '#1a2741',
    background_color: '#c34614',
    foreground_text_color: '#ffffff',
    background_text_color: '#ffffff',
    include_period_name: true,
    use_schedule_color: true
};
// Start helpers
let $6ccd80391c1df6b7$var$lastFetchedData = null;
const $6ccd80391c1df6b7$var$serverOffset = null;
async function $6ccd80391c1df6b7$var$get(endpoint = '/api/v1/today/now/near') {
    return fetch(`${endpoint}?timestamp=${Math.floor($6ccd80391c1df6b7$var$current_date().getTime() / 1000)}`).then((x)=>x.json().catch(()=>null)).catch(()=>null);
}
let $6ccd80391c1df6b7$var$config;
function $6ccd80391c1df6b7$var$updateConfig() {
    $6ccd80391c1df6b7$var$config = Object.assign($6ccd80391c1df6b7$var$DEFAULT_CONFIG, JSON.parse(localStorage.getItem('schedule') || '{}'));
    return $6ccd80391c1df6b7$var$config;
}
$6ccd80391c1df6b7$var$updateConfig();
function $6ccd80391c1df6b7$var$replace_period(period) {
    if (!period) return period;
    if (Array.isArray(period)) return period.map((v)=>$6ccd80391c1df6b7$var$replace_period(v));
    const period_tmp = Object.assign({}, period);
    const class_id = period_tmp.kind.Class || period_tmp.kind.ClassOrLunch;
    const class_cfg = $6ccd80391c1df6b7$var$config.schedule[class_id] || $6ccd80391c1df6b7$var$config.schedule[period_tmp.friendly_name];
    if (class_cfg) {
        if (class_cfg.name) period_tmp.friendly_name = $6ccd80391c1df6b7$var$config.include_period_name || $6ccd80391c1df6b7$var$config.include_period_name === undefined ? `${period_tmp.friendly_name} - ${class_cfg.name}` : class_cfg.name;
        if (class_cfg.url) period_tmp.url = class_cfg.url;
    }
    return period_tmp;
}
function $6ccd80391c1df6b7$var$process(data) {
    if ($6ccd80391c1df6b7$var$config) return data.map((v)=>$6ccd80391c1df6b7$var$replace_period(v));
    return data;
}
function $6ccd80391c1df6b7$var$period_html(period) {
    return period ? period.url ? `<a href=${period.url}>${period.friendly_name.replaceAll('<', '&lt;').replaceAll('>', '&gt;')}</a>` : period.friendly_name.replaceAll('<', '&lt;').replaceAll('>', '&gt;') : 'None';
}
function $6ccd80391c1df6b7$var$getel(id) {
    return document.querySelector(`#${id}`);
}
async function $6ccd80391c1df6b7$var$go(display) {
    if ($6ccd80391c1df6b7$var$lastFetchedData) display($6ccd80391c1df6b7$var$lastFetchedData);
    const now = Date.now();
    const endOfMinute = Math.ceil(now / 60000) * 60000;
    setTimeout(()=>$6ccd80391c1df6b7$var$go(display), endOfMinute - now);
    let data = await $6ccd80391c1df6b7$var$get();
    if (!data) return;
    data = $6ccd80391c1df6b7$var$process(data);
    $6ccd80391c1df6b7$var$lastFetchedData = data;
    display(data);
}
function $6ccd80391c1df6b7$var$human_list(items) {
    let output = '';
    if (items.length === 1) return items[0].toString();
    for(let i = 0; i < items.length; i++){
        if (i === items.length - 1) output += `${items.length > 2 ? ', ' : ' '}and ${items[i].toString()}`;
        else if (i === 0) output += items[i].toString();
        else output += `, ${items[i].toString()}`;
    }
    return output;
}
// Add plural suffix to a unit
function $6ccd80391c1df6b7$var$plural_suffix(number, string) {
    return `${string}${number === 1 ? '' : 's'}`;
}
// Gets current date
// If timestamp query string is provided, that is used instead of current.
function $6ccd80391c1df6b7$var$current_date() {
    const timestampQueryString = new URLSearchParams(window.location.search).get('timestamp');
    if (timestampQueryString) return new Date(Number.parseInt(timestampQueryString, 10) * 1000);
    return new Date();
}
function $6ccd80391c1df6b7$var$date_from_api(time, now = $6ccd80391c1df6b7$var$current_date()) {
    const [h, m, s] = time.split(':');
    const date = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), h, m, s);
    return date;
}
// YYYY-MM-DD to Date object
function $6ccd80391c1df6b7$var$date_string_to_date(dateString) {
    const [y, m, d] = dateString.split('-');
    return new Date(Number.parseInt(y, 10), Number.parseInt(m, 10) - 1, Number.parseInt(d, 10));
}
function $6ccd80391c1df6b7$var$human_time(time) {
    const date = $6ccd80391c1df6b7$var$date_from_api(time);
    return date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit'
    });
}
// Gets a human readable duration from an epoch timestamp
function $6ccd80391c1df6b7$var$human_time_left(endTime, startTime = null, short = false) {
    /**
	* Convert time string to ms, on the same day as `current_date()`
	* (Date is created in local time)
	* @param {string} time - HH:MM:SS string
	*/ const hmsToMs = (time)=>{
        const [h, m, s] = time.split(':');
        const now = $6ccd80391c1df6b7$var$current_date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate(), h, m, s).getTime();
    };
    const startDate = startTime ? hmsToMs(startTime) : $6ccd80391c1df6b7$var$current_date().getTime();
    const endDate = hmsToMs(endTime);
    const timeLeft = Math.floor((endDate - startDate) / 1000);
    const h = Math.floor(timeLeft / 60 / 60);
    const m = Math.ceil(timeLeft / 60 % 60);
    if (short) {
        if (h > 0) return `${h}h ${m}m`;
        return `${m}m`;
    }
    if (h > 0) return `${h} ${$6ccd80391c1df6b7$var$plural_suffix(h, 'hour')} and ${m} ${$6ccd80391c1df6b7$var$plural_suffix(m, 'minute')}`;
    return `${m} ${$6ccd80391c1df6b7$var$plural_suffix(m, 'minute')}`;
}
// Convert date object to YYYY-MM-DD
function $6ccd80391c1df6b7$var$date_to_string(date = $6ccd80391c1df6b7$var$current_date(), utc = true) {
    if (utc) return `${date.getUTCFullYear()}-${('0' + (date.getUTCMonth() + 1)).slice(-2)}-${('0' + date.getUTCDate()).slice(-2)}`;
    return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
}
// Helper functions for full screen
function $6ccd80391c1df6b7$var$enterFullScreen(element = document.documentElement) {
    if (element.requestFullscreen) element.requestFullscreen();
    else if (element.webkitRequestFullscreen) element.webkitRequestFullscreen();
    else if (element.mozRequestFullScreen) element.mozRequestFullScreen();
    else if (element.msRequestFullscreen) element.msRequestFullscreen();
}
function $6ccd80391c1df6b7$var$exitFullscreen() {
    if (document.exitFullscreen) document.exitFullscreen();
    else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
    else if (document.mozExitFullScreen) document.mozExitFullScreen();
    else if (document.msExitFullscreen) document.msExitFullscreen();
}
function $6ccd80391c1df6b7$var$canFullScreen() {
    return document.fullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled;
}
function $6ccd80391c1df6b7$var$isFullScreen() {
    return (document.fullscreenElement || document.mozFullScreenElement || document.webkitIsFullScreen || document.msFullscreenElement || null) !== null;
}
function $6ccd80391c1df6b7$var$toggleFullScreen(element) {
    if ($6ccd80391c1df6b7$var$canFullScreen()) {
        if ($6ccd80391c1df6b7$var$isFullScreen()) $6ccd80391c1df6b7$var$exitFullscreen();
        else $6ccd80391c1df6b7$var$enterFullScreen(element);
    }
}
window.addEventListener('load', ()=>{
    if (!document.querySelector('nav')) return;
    const nav_links = document.querySelector('#nav-links');
    document.querySelector('#nav-toggle-button').addEventListener('click', ()=>{
        nav_links.classList.toggle('show');
        nav_links.style.maxHeight = nav_links.classList.contains('show') ? nav_links.querySelector('ul').clientHeight + 'px' : '';
    });
});
window.addEventListener('resize', ()=>{
    if (!document.querySelector('nav')) return;
    const nav_links = document.querySelector('#nav-links');
    if (nav_links.classList.contains('show')) nav_links.style.maxHeight = nav_links.querySelector('ul').clientHeight + 'px';
});
// Convert array of RGB to hex
function $6ccd80391c1df6b7$var$bytes_to_color(bytes) {
    return '#' + bytes.map((b)=>('0' + b.toString(16)).slice(-2)).join('');
}
// Detect whether text should be black or white based on the background color
function $6ccd80391c1df6b7$var$black_or_white(color, opacity = 1) {
    if (!color.startsWith('#')) color = `#${color}`;
    const r = Number.parseInt(color.slice(1, 3), 16);
    const g = Number.parseInt(color.slice(3, 5), 16);
    const b = Number.parseInt(color.slice(5, 7), 16);
    const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    return luma > 128 ? `rgba(0, 0, 0, ${opacity})` : `rgba(255, 255, 255, ${opacity})`;
}
async function $6ccd80391c1df6b7$var$getServerOffset() {
    const response = await fetch('/api/v1/what-time-is-it');
    const data = await response.text();
    const offset = data.split(' ')[5];
    const h = Number.parseInt(offset.slice(0, -2), 10);
    const m = Number.parseInt(offset.slice(-2), 10);
    const serverUTCOffset = h * 60 + m;
    const utcOffset = new Date().getTimezoneOffset();
    const serverOffset = -serverUTCOffset - utcOffset;
    return serverOffset * 60000;
}
// Apply user colors
window.addEventListener('load', ()=>{
    $6ccd80391c1df6b7$var$setTheme();
});
function $6ccd80391c1df6b7$var$setTheme() {
    const cfg = $6ccd80391c1df6b7$var$config || {};
    const setBg = !(window.location.pathname === '/' && cfg.use_schedule_color);
    document.querySelector('meta[name=theme-color]').setAttribute('content', cfg.foreground_color || '#1a2741');
    if (setBg && cfg.background_color) document.querySelector('body').style.setProperty('--background_color', cfg.background_color || '#c34614');
    if (cfg.foreground_color) document.querySelector('body').style.setProperty('--foreground_color', cfg.foreground_color || '#1a2741');
    if (setBg && cfg.background_text_color) document.querySelector('body').style.setProperty('--background_text_color', cfg.background_text_color || '#ffffff');
    if (cfg.foreground_text_color) document.querySelector('body').style.setProperty('--foreground_text_color', cfg.foreground_text_color || '#ffffff');
}
function $6ccd80391c1df6b7$var$broadcastConfigToExtension() {
    $6ccd80391c1df6b7$var$updateConfig();
    if ('chrome' in window && chrome.runtime !== undefined) chrome.runtime.sendMessage('gbkjjbecehodfeijbdmoieepgmfdlgle', {
        message: 'schedule',
        data: JSON.stringify($6ccd80391c1df6b7$var$config)
    });
}
function $6ccd80391c1df6b7$var$setCookie(name, value, expires = 2 ** 31 * 1000, path = '/') {
    document.cookie = `${name}=${encodeURIComponent(value)}; ${expires ? `expires=${new Date(expires).toUTCString()}; ` : ''}path=${path}`;
}
function $6ccd80391c1df6b7$var$getCookie(name) {
    return document.cookie.split('; ').reduce((r, v)=>{
        const parts = v.split('=');
        return parts[0] === name ? decodeURIComponent(parts[1]) : r;
    }, '');
}
function $6ccd80391c1df6b7$var$deleteCookie(name, path) {
    $6ccd80391c1df6b7$var$setCookie(name, '', null, path);
}
$6ccd80391c1df6b7$var$broadcastConfigToExtension();
Object.assign(window, {
    black_or_white: $6ccd80391c1df6b7$var$black_or_white,
    bytes_to_color: $6ccd80391c1df6b7$var$bytes_to_color,
    canFullScreen: $6ccd80391c1df6b7$var$canFullScreen,
    current_date: $6ccd80391c1df6b7$var$current_date,
    date_from_api: $6ccd80391c1df6b7$var$date_from_api,
    date_string_to_date: $6ccd80391c1df6b7$var$date_string_to_date,
    date_to_string: $6ccd80391c1df6b7$var$date_to_string,
    enterFullScreen: $6ccd80391c1df6b7$var$enterFullScreen,
    exitFullscreen: $6ccd80391c1df6b7$var$exitFullscreen,
    get: $6ccd80391c1df6b7$var$get,
    getel: $6ccd80391c1df6b7$var$getel,
    go: $6ccd80391c1df6b7$var$go,
    human_list: $6ccd80391c1df6b7$var$human_list,
    human_time: $6ccd80391c1df6b7$var$human_time,
    human_time_left: $6ccd80391c1df6b7$var$human_time_left,
    isFullScreen: $6ccd80391c1df6b7$var$isFullScreen,
    period_html: $6ccd80391c1df6b7$var$period_html,
    plural_suffix: $6ccd80391c1df6b7$var$plural_suffix,
    process: $6ccd80391c1df6b7$var$process,
    replace_period: $6ccd80391c1df6b7$var$replace_period,
    toggleFullScreen: $6ccd80391c1df6b7$var$toggleFullScreen,
    put_period_to_element: $6ccd80391c1df6b7$var$put_period_to_element,
    setTheme: $6ccd80391c1df6b7$var$setTheme,
    broadcastConfigToExtension: $6ccd80391c1df6b7$var$broadcastConfigToExtension,
    setCookie: $6ccd80391c1df6b7$var$setCookie,
    getCookie: $6ccd80391c1df6b7$var$getCookie,
    deleteCookie: $6ccd80391c1df6b7$var$deleteCookie,
    config: $6ccd80391c1df6b7$var$config,
    DEFAULT_CONFIG: $6ccd80391c1df6b7$var$DEFAULT_CONFIG
});
// Writes a period to an element and its children
function $6ccd80391c1df6b7$var$put_period_to_element(element, period) {
    if (period) {
        if (period.kind === 'BeforeSchool') {
            element.innerHTML = 'School hasn\'t started yet!';
            return false;
        }
        if (period.kind === 'AfterSchool') {
            element.innerHTML = 'School\'s out!';
            return false;
        }
        element.innerHTML = element.innerHTML.replaceAll('{START}', $6ccd80391c1df6b7$var$human_time(period.start)).replaceAll('{END}', $6ccd80391c1df6b7$var$human_time(period.end)).replaceAll('{START_IN}', $6ccd80391c1df6b7$var$human_time_left(period.start, undefined, true)).replaceAll('{END_IN}', $6ccd80391c1df6b7$var$human_time_left(period.end, undefined, true)).replaceAll('{NAME}', period.url ? `<a href="${period.url}">${period.friendly_name}</a>` : period.friendly_name);
        return true;
    }
    element.innerHTML = 'No School';
    return false;
}
if (new URLSearchParams(window.location.search).get('fullscreen') !== null) document.querySelector('nav').style.display = 'none';


//# sourceMappingURL=timeline.595bf55f.js.map
